import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { InventoryRatioPage } from "@/features/inventory";

interface InventoryRatioSearch {
  sku?: string;
}

function InventoryRatioRoute(): JSX.Element {
  const { sku } = Route.useSearch();
  return <InventoryRatioPage initialSku={sku ?? ""} />;
}

export const Route = createFileRoute("/_authenticated/inventory-ratio")({
  validateSearch: (raw: Record<string, unknown>): InventoryRatioSearch => {
    const sku = typeof raw.sku === "string" ? raw.sku.trim() : "";
    return sku ? { sku } : {};
  },
  component: InventoryRatioRoute,
});
